const host=window.location.hostname
// const apiurl="http://localhost:0777"
// const apiurl="https://backend.rddunified.com"
const apiurl="https://dev.rddunified.com"
export {apiurl,host}